module.exports = __webpack_public_path__ + "static/media/AboutRyan.148a3bf9.jpg";